
import React from "react";
import Slider from "react-slick";
import ReactCompareImage from "react-compare-image";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
;
const BeforeAfterCavitiesSection = (props) => {
    const {cavitiesBefore1,cavitiesBefore2,cavitiesBefore3,cavitiesAfter1,cavitiesAfter2,cavitiesAfter3} = props
    const NextArrow = ({ onClick }) => (
        <div className="cavities-arrow cavities-right" onClick={onClick}>
            <FaChevronRight />
        </div>
    );

    const PrevArrow = ({ onClick }) => (
        <div className="cavities-arrow cavities-left" onClick={onClick}>
            <FaChevronLeft />
        </div>
    );

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        draggable: false,
    };

    const imagePairs = [
        { before: cavitiesBefore1, after: cavitiesAfter1 },
        { before: cavitiesBefore2, after: cavitiesAfter2 },
        { before: cavitiesBefore3, after: cavitiesAfter3 },
    ];

    return (
        <div className="cavities-main">
            <div className="arrow-container">
                <Slider {...settings}>
                    {imagePairs.map((pair, index) => (
                        <div key={index} className="slider-item">
                            <ReactCompareImage leftImage={pair.before} rightImage={pair.after} />
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default BeforeAfterCavitiesSection;
